// src/components/RoleRoute.js

import React from "react";
import { Navigate, useLocation } from "react-router-dom";

const RoleRoute = ({ role, allowed, children }) => {
  const location = useLocation();

  // Always use the currently selected role.
  const activeRole = localStorage.getItem("activeRole") || role || "";

  console.log("ROLE ROUTE CHECK >>>", {
    path: location.pathname,
    role,
    activeRole,
    allowed,
  });

  // Still loading role information
  if (!activeRole) {
    console.log("ROLE ROUTE WAITING FOR ROLE");
    return null;
  }

  // Role is allowed
  if (allowed.includes(activeRole)) {
    console.log("ROLE ROUTE ALLOWED >>>", {
      path: location.pathname,
      activeRole,
      allowed,
    });

    return children;
  }

  // IMPORTANT:
  // Do NOT send a multi-role user to login.
  // Send them to the dashboard corresponding to their active role.
  console.log("ROLE ROUTE REDIRECT >>>", {
    activeRole,
    allowed,
  });

  if (activeRole === "Admin") {
    return <Navigate to="/dashboard/admin" replace />;
  }

  if (activeRole === "Instructor") {
    return <Navigate to="/dashboard/instructor" replace />;
  }

  if (activeRole === "Student") {
    return <Navigate to="/dashboard/student" replace />;
  }

  return <Navigate to="/login" replace />;
};

export default RoleRoute;